<div class="profile-form__form-container">
  <form [formGroup]="userProfileForm" (ngSubmit)="onSubmit(f)" #f="ngForm">
    <h4>Change your personal details</h4>
    <br>
    <div class="profile-form__form-container-row">
      <mat-form-field class="default-form-input-container" appearance="outline">
        <span class="profile-form__icon"><i class="material-icons">person</i></span>
        <input matInput placeholder="Type a name" [formControlName]="'firstName'" required>
      </mat-form-field>
    </div>
    <div class="profile-form__form-container-row">
      <mat-form-field class="default-form-input-container" appearance="outline">
        <input matInput placeholder="Middle name(s)" [formControlName]="'middleName'">
      </mat-form-field>
    </div>
    <div class="profile-form__form-container-row">
      <mat-form-field class="default-form-input-container" appearance="outline">
        <input matInput placeholder="Surname" [formControlName]="'lastName'" required>
      </mat-form-field>
    </div>
    <div class="profile-form__form-container-row">
      <mat-form-field class="default-form-input-container" appearance="outline">
        <input (ngModelChange)="onInputChange(f)" matInput placeholder="E-mail address" [formControlName]="'email'"
          required>
      </mat-form-field>
    </div>
    <div class="profile-form__form-container-row">
      <mat-form-field appearance="outline" class="default-form-input-container">
        <input (ngModelChange)="onInputChange(f)" matInput placeholder="Phone number" [formControlName]="'phone'"
          type="tel" maxlength=10>
      </mat-form-field>
    </div>
    <div *ngIf="taxInputEnabled" class="profile-form__form-container-row">
      <h5 *ngIf="isKiwiSaver" class="icon-header secondary-header-text medium-element-margin--bottom" for="taxNumber">
        IRD number
        <i class="material-icons primary-accent" [popper]="IRDHelp" [popperTrigger]="'click'"
          [popperHideOnClickOutside]="true" [popperHideOnScroll]="true" [popperApplyClass]="'popper_content'"
          [popperApplyArrowClass]="'popper_arrow'">help</i>
      </h5>
      <mat-form-field appearance="outline">
        <input matInput placeholder="IRD number" (ngModelChange)="onInputChange(f)" [formControlName]="'taxNumber'"
          (focusout)="formatIrd($event)" type="text" maxlength="11">
      </mat-form-field>
      <popper-content #IRDHelp>
        <p>
          Your IRD number is your unique identifier for your KiwiSaver account.
          You keep the same IRD number for life. If you have any questions please
          <span *ngIf="supportPhone"> call us on {{supportPhone}} or </span>
          email <a *ngIf="supportEmail" href='mailto:{{supportEmail}}' target="_blank">{{supportEmail}}</a>
        </p>
      </popper-content>
      <div *ngIf="!isKiwiSaver" class="half-default-element-margin--top">
        <mat-checkbox disableRipple style="margin-right: 12px;" (change)="onCheckIRDUnavailable($event)"
          [checked]="irdUnavailable"></mat-checkbox>
        I don't have an IRD number.
      </div>
    </div>
    <div *ngIf="showFormUpdatedSuccess" class="profile-form__form-container-row mat-form-success">
      <p class="success-text">
        <i class="material-icons">
          done
        </i>
        <span class="success-text-arrow"></span>{{successText}}
      </p>
    </div>
    <mat-error *ngIf="phoneNumberInvalid">
      Phone number is not valid
    </mat-error>
    <div class="account-profile-form-footer">
      <button disableRipple class="a-rounded-button--primary a-rounded-button--medium form dialog__form-footer-button"
        type="submit" [disabled]="!f.valid || !enableSubmitButton">{{ 'Save' }}</button>
      <button disableRipple
        class="a-rounded-button--primary-outline a-rounded-button--medium form dialog__form-footer-button" type="button"
        (click)="onResetAndClose()">{{ 'Cancel' }}</button>
    </div>
  </form>
</div>
<app-spinner *ngIf="showSpinner" class="spinner spinner_left"></app-spinner>